if ($("#ordering_disabled_modal").hasClass("in")) {
  var bd = $('<div class="ordering-disabled-modal-backdrop in"></div>');
  $("body").append(bd);

  $("#ordering_disabled_modal .modal-footer .btn").click(function() {
    $("#ordering_disabled_modal").removeClass("in");
    bd.remove();
  });
}
